import { TransformKind } from "../display/SpriteConst";
import { LayoutBox } from "./LayoutBox";
export class VBox extends LayoutBox {
    constructor() {
        super(...arguments);
        this.isSortItem = false;
    }
    get autoSizeMode() {
        return this._autoSizeMode;
    }
    set autoSizeMode(value) {
        if (this._autoSizeMode !== value) {
            this._autoSizeMode = value;
            this.callLater(this.changeItems);
        }
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Width) != 0)
            this.callLater(this.changeItems);
    }
    sortItem(items) {
        if (items)
            items.sort(function (a, b) { return a.y - b.y; });
    }
    changeItems() {
        this._itemChanged = false;
        const items = [];
        let maxChildWidth = 0;
        let totalChildHeight = 0;
        for (let i = 0, n = this.numChildren; i < n; i++) {
            const item = this.getChildAt(i);
            if (this.skipHidden && !item.visible)
                continue;
            if (!item)
                continue;
            item.y = 0;
            items.push(item);
            const iw = item.width * item.scaleX;
            const ih = item.height * item.scaleY;
            if (iw > maxChildWidth)
                maxChildWidth = iw;
            totalChildHeight += ih;
        }
        if (this.isSortItem) {
            this.sortItem(items);
        }
        const alignWidth = (this._autoSizeMode === VBox.AUTO_SIZE_BOTH) ? maxChildWidth : (this._isWidthSet ? this._width : maxChildWidth);
        let top = 0;
        for (let i = 0, n = items.length; i < n; i++) {
            const item = items[i];
            const iw = item.width * item.scaleX;
            const ih = item.height * item.scaleY;
            item.y = top;
            top += ih + this._space;
            switch (this._align) {
                case VBox.LEFT:
                    item.x = 0;
                    break;
                case VBox.CENTER:
                    item.x = (alignWidth - iw) * 0.5;
                    break;
                case VBox.RIGHT:
                    item.x = alignWidth - iw;
                    break;
            }
        }
        if (this._autoSizeMode === VBox.AUTO_SIZE_BOTH) {
            this.size(maxChildWidth, this._calcSizeWithSpace(totalChildHeight, items.length));
        }
        else if (this._autoSizeMode === VBox.AUTO_SIZE_HEIGHT) {
            this.size(this.width, this._calcSizeWithSpace(totalChildHeight, items.length));
        }
        this._sizeChanged();
    }
}
VBox.NONE = "none";
VBox.LEFT = "left";
VBox.CENTER = "center";
VBox.RIGHT = "right";
VBox.AUTO_SIZE_HEIGHT = "height";
